import { TabWithRoute } from "../../core/models/fvs-address-verification.model"; 

class FVSConstants {
  static readonly routes = {
    parent: 'fvs-address-verification',
    myTasks: 'my-tasks',
    unAssignedTasks: 'unassigned-tasks',
    overdueTasks: 'overdue-tasks',
    priorityBOs: 'priority-bos',
    editPriorityBOs: 'edit-priority-bos',
    updateBRMLGAOnFVS: 'update-lga',
  } as const;

    static readonly menus = {
        addressVerification: 'Address Verification',
        parent: 'Verification',
    };

    static readonly icons = {
        edit: 'edit',
        address: 'address',
        filter: 'filter',
    };

    static readonly tabListWithRoute: TabWithRoute = {
        myTasks: {
            route: FVSConstants.routes.myTasks,
            name: 'My Tasks',
            show: true,
        },
        unAssignedTasks: {
            route: FVSConstants.routes.unAssignedTasks,
            name: 'Unassigned Tasks',
            show: true,
        },
        overdueTasks: {
            route: FVSConstants.routes.overdueTasks,
            name: 'Overdue Tasks',
            show: true,
        },
        priority: {
            route: FVSConstants.routes.priorityBOs,
            name: 'Priority BOs',
            show: true,
        },
    };

    static readonly chipStatus = {
        pending: 'PENDING',
        active: 'ACTIVE',
    } as const;

    static readonly FILE_SIZE_ERROR = 'File size must not be greater than 2MB';

    static readonly routeStateKeys = {
        apiMessage: 'apiMessage',
        isFlagEnabled: 'isFlagEnabled',
    } as const;

    static readonly searchDebounceTime = 1000;

    static readonly fvsOnboardingStatus = {
        onboardedWithRegisteredLGA: 'onboarded-with-registered-lga',
        onboardedWithoutRegisteredLGA: 'onboarded-without-registered-lga',
        notOnboarded: 'not-onboarded',
    };

    static readonly addressVerificationTypes = {
        business: 'BUSINESS_ADDRESS',
        individual: 'INDIVIDUAL_ADDRESS',
    } as const;
}

export default FVSConstants;
